export default "__VITE_ASSET__DjQ9gosJ__"